const locationFacilityTypes = {
  create: 'Erstellen',
  update: 'Aktualisieren',
  facilityType: {
    school: 'Schule',
    work: 'Arbeitsplatz',
  },
  toasts: {
    delete: {
      success: '[Location Facility] wurde erfolgreich gelöscht',
      errorMessage: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.',
    },
    create: {
      success: '[Location Facility] wurde erfolgreich erstellt',
      error: '[Location Facility] ungültige Serverantwort',
    },
    update: {
      success: '[Location Facility] wurde erfolgreich aktualisiert',
      error: '[Location Facility] ungültige Serverantwort',
    },
  },
  deleteModal: {
    header: 'Einrichtungen löschen',
    body: 'Möchten Sie {{num}} Einrichtungen wirklich löschen?',
  },
  table: {
    headers: {
      name: 'Name',
      type: 'Typ',
      facilityTypes: 'Typ',
      contactName: 'Kontakt',
      email: 'E-Mail',
      phone: 'Telefonnummer',
      address: 'Adresse',
      profile: 'Profil',
    },
    filters: {
      type: 'Typ',
    },
    actions: {
      delete: 'Löschen',
    },
  },
  form: {
    tabs: {
      general: 'Standortinfo',
      contact: 'Kontaktinfo',
      hours: 'Zeiten',
      advancedSettings: 'Präferenzen',
      holidays: 'Feiertage',
    },
    forms: {
      general: {
        header: '{{type}}-Standort',
        fields: {
          name: '{{type}}-Name',
          address: '{{type}}-Adresse',
          type: 'Einrichtungstyp',
          radius: {
            title: 'Adressabgleich-Radius',
            description:
              'Der Radius in Metern oder Fuß (m/ft für metrisch/imperial), innerhalb dessen Reservierungen als Standort und/oder als Wait-and-Return erkannt werden.',
          },
        },
      },
      contacts: {
        header: 'Kontakt: {{index}}',
        fields: {
          comment: 'Kommentar',
          address: 'Adresse',
          fax: 'Fax',
          phone: 'Telefon',
          email: 'E-Mail',
          type: 'Typ',
          name: 'Name',
        },
        actions: {
          add: 'Kontakt hinzufügen +',
        },
      },
      shiftsHours: {
        header: {
          school: 'Schulzeiten',
          work: 'Arbeitszeiten',
        },
        fields: {
          name: 'Name',
          status: 'Status',
          start: 'Start',
          end: 'Ende',
          type: {
            title: 'Typ',
            options: {
              collect: 'Abholen',
              distribute: 'Verteilen',
              both: 'Beides',
            },
          },
          weekDays: 'Wochentage',
        },
        actions: {
          add: {
            default: '+ Hinzufügen',
            school: '+ Schulzeiten hinzufügen',
            work: '+ Arbeitszeiten hinzufügen',
          },
        },
      },
      reservationPreferences: {
        header: 'Reservierungspräferenzen',
        fields: {
          sharedWithOther: 'Mit anderen geteilt',
          profile: 'Profil',
          suppliers: 'Lieferanten',
          service: 'Service',
        },
      },
      advancedSettings: {
        header: 'Erweiterte Einstellungen',
        fields: {
          consistentPassengerRouting: {
            title: 'Konstante Fahrgast-Routenführung',
            toolTipInformation:
              'Stellt sicher, dass dieselbe Fahrgastgruppe immer derselben Route zur und von der Einrichtung folgt, optimiert die Reiseeffizienz und minimiert Verwirrung.',
          },
          sameDriverForGroup: {
            title: 'Gleicher Fahrer für Gruppe',
            toolTipInformation:
              'Weist denselben Fahrer zu, um die Fahrgastgruppe sowohl beim Abholen als auch beim Absetzen zu transportieren, und sorgt so für Vertrautheit und Konsistenz für die Fahrgäste.',
          },
          allowSharedRide: {
            title: 'Gemeinsame Fahrt mit anderen Adressen zulassen',
            toolTipInformation:
              'Wenn aktiviert, erlaubt diese Einstellung, dass gemeinsame Fahrten mit Buchungen von anderen Standorten mit konsistenten Routen gruppiert werden. Wenn deaktiviert, werden nur Fahrten vom selben Standort für die Gruppierung berücksichtigt.',
          },
          tripBoardingTime: {
            title: 'Einsteigezeit',
            toolTipInformation:
              'Die Zeit, die zum Abholen eines Fahrgasts an seinem Halt benötigt wird (Dieser Parameter beeinflusst die Gesamtreisedauer)',
          },
          waitForBoardingTime: {
            title: 'Wartezeit für Einsteigen',
            toolTipInformation: 'Beim Erreichen eines Halts wartet der Fahrer bei Bedarf bis zur genauen Abholzeit.',
          },
          tripDropOffTime: {
            title: 'Ausstiegszeit',
            toolTipInformation:
              'Die Zeit, die zum Absetzen eines Fahrgasts an seinem Halt benötigt wird (Dieser Parameter beeinflusst die Gesamtreisedauer)',
          },
          rules: {
            header: 'Standort-/Profilregeln',
            rule: 'Regel',
            profiles: 'Profile',
            addNewRule: '+ Standort-/Profilregel hinzufügen',
          },
          maxDropOffEarly: {
            title: 'Max. Frühankunft beim Absetzen',
            toolTipInformation:
              'Maximale Anzahl an Minuten, die ein Fahrer früher ankommen darf im Verhältnis zur in der Reservierung festgelegten Absetzzeit',
          },
          maxDropOffDelay: {
            title: 'Max. Verspätung beim Absetzen',
            toolTipInformation:
              'Maximale Anzahl an Minuten, die ein Fahrer zu spät sein darf im Verhältnis zur in der Reservierung festgelegten Absetzzeit',
          },
          maxBoardingDelay: {
            title: 'Max. Verspätung beim Abholen',
            toolTipInformation:
              'Maximale Anzahl an Minuten, die ein Fahrer zu spät sein darf im Verhältnis zur in der Reservierung festgelegten Abholzeit',
          },
          maxBoardingEarly: {
            title: 'Max. Frühankunft beim Abholen',
            toolTipInformation:
              'Maximale Anzahl an Minuten, die ein Fahrer früher ankommen darf im Verhältnis zur in der Reservierung festgelegten Abholzeit',
          },
          maxTripDuration: {
            title: 'Max. Fahrtdauer',
            toolTipInformation: 'Maximale Dauer einer Fahrt in Minuten',
          },
          maxSinglePassengerTime: {
            title: 'Max. Einzelfahrgast-Fahrtdauer',
            toolTipInformation: 'Maximale Dauer einer Fahrt in Minuten pro Fahrgast',
          },
        },
      },
      excludedDrivers: {
        header: 'Ausgeschlossene Fahrer',
        fields: {
          driversList: 'Fahrerliste',
          excludedList: 'Ausschlussliste',
        },
      },
      excludedVehicles: {
        header: 'Ausgeschlossene Fahrzeuge',
        fields: {
          vehiclesList: 'Fahrzeugliste',
          excludedList: 'Ausschlussliste',
        },
      },
      excludeHolidays: {
        header: 'Ausgeschlossene Feiertage',
        fields: {
          holidaysList: 'Feiertagsliste',
          excludedList: 'Ausgeschlossene Feiertage',
        },
      },
    },
  },
};

export default locationFacilityTypes;
